import { render, staticRenderFns } from "./closeProjectModal.vue?vue&type=template&id=864b2ae2&"
import script from "./closeProjectModal.vue?vue&type=script&lang=js&"
export * from "./closeProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports